<template>
  <div
    v-if="total > 0"
    class="wrapper"
  >
    <p class="resultsFromTo">{{ from }} - {{ to }}</p>
    <div v-if="lastPage !== 1">
      <button
        type="button"
        class="nextPreviousButton"
        :disabled="from === 1"
        @click="() => goToPage(currentPage - 1)"
      >
        <font-awesome-icon icon="chevron-left"/>
      </button>
      <ul
        v-if="currentPage > 1"
        class="otherPages"
      >
        <li v-if="currentPage > 1">
          <button
            class="pageButton"
            @click="() => goToPage(1)"
          >
            1
          </button>
        </li>
        <li v-if="currentPage > 4">...</li>
        <li v-if="currentPage > 3">
          <button
            class="pageButton"
            @click="() => goToPage(currentPage - 2)"
          >
            {{ currentPage - 2 }}
          </button>
        </li>
        <li v-if="currentPage > 2">
          <button
            class="pageButton"
            @click="() => goToPage(currentPage - 1)"
          >
            {{ currentPage - 1 }}
          </button>
        </li>
      </ul>
      <span class="currentPage">{{ currentPage }}</span>
      <ul
        v-if="lastPage > currentPage"
        class="otherPages"
      >
        <li v-if="lastPage > (currentPage + 1)">
          <button
            class="pageButton"
            @click="() => goToPage(currentPage + 1)"
          >
            {{ currentPage + 1 }}
          </button>
        </li>
        <li v-if="lastPage > (currentPage + 2)">
          <button
            class="pageButton"
            @click="() => goToPage(currentPage +2)"
          >
            {{ currentPage + 2 }}
          </button>
        </li>
        <li v-if="lastPage > (currentPage + 3)">...</li>
        <li v-if="lastPage > currentPage">
          <button
            class="pageButton"
            @click="() => goToPage(lastPage)"
          >
            {{ lastPage }}
          </button>
        </li>
      </ul>
      <button
        type="button"
        class="nextPreviousButton"
        :disabled="to === total"
        @click="() => goToPage(currentPage + 1)"
      >
        <font-awesome-icon icon="chevron-right"/>
      </button>
    </div>
  </div>
</template>

<style scoped>
  .wrapper {
    text-align: center;
  }

  .resultsFromTo {
    margin: 0 0 20px 0;
    padding: 0;
    font-weight: 600;
    color: var(--secondary-text-color);
  }

  .currentPage {
    padding: 0 20px;
    font-size: 1.8rem;
    font-weight: 600;
    color: var(--primary-color);
  }

  .otherPages {
    display: inline;
    padding: 0;
    list-style-type: none;
  }

  .otherPages > li {
    display: inline;
    margin: 0 10px;
  }

  .nextPreviousButton {
    width: 30px;
    height: 30px;
    font-size: 1.8rem;
    color: var(--primary-color);
    background-color: transparent;
    border: none;
    border-radius: 100%;
    cursor: pointer;
    transition-property: background-color;
    transition-duration: 0.2s;
  }

  .nextPreviousButton:hover {
    background-color: var(--secondary-color);
  }

  .nextPreviousButton:disabled {
    color: var(--secondary-text-color);
    cursor: default;
  }

  .nextPreviousButton:disabled:hover {
    background-color: transparent;
  }

  .pageButton {
    width: 30px;
    height: 30px;
    margin: 0;
    padding: 0;
    background-color: transparent;
    border: none;
    cursor: pointer;
  }

  .pageButton:hover {
    background-color: var(--secondary-color);
    border-radius: 100%;
    transition-property: background-color;
    transition-duration: 0.2s;
  }
</style>

<script>
  export default {
    props: [
      'currentPage',
      'lastPage',
      'from',
      'to',
      'total',
      'goToPage'
    ]
  }
</script>
